import React, { useState } from 'react';
import axios from 'axios';
import {
  PdsModal,
  PdsModalHeader,
  PdsModalBody,
  PdsModalFooter,
  PdsBox,
  PdsMantineButton,
  PdsTextField,
  PdsTextArea,
  PdsNotification,
  PdsSpinnerIcon,
  PdsCheckConfirmIcon,
} from '@podium-design-system/react-components';

/**
 * Edit case metadata (target, title, description, JIRA). Shared by Case Details and home case cards.
 */
export default function CaseEditModal({ caseData, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    target: caseData.target || '',
    title: caseData.title || '',
    description: caseData.description || '',
    jiraId: caseData.jiraId || '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    setSubmitting(true);
    setError(null);
    try {
      const response = await axios.put(`/api/cases/${caseData.id}`, formData);
      onSuccess(response.data);
    } catch (err) {
      setError('Failed to update case: ' + (err.response?.data?.message || err.message));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <PdsModal show onDismiss={onClose} minWidth="460px" maxWidth="560px" minHeight="auto" maxHeight="90vh">
      <PdsModalHeader headline="Edit Case" />
      <PdsModalBody>
        <PdsBox direction="column" gap="md" style={{ width: '100%' }}>
          {error && <PdsNotification color="warning" dismissible={false}>{error}</PdsNotification>}
          <PdsTextField
            label="URL/IP/Entity"
            placeholder="Domain, IP, or other target"
            value={formData.target}
            onChange={(e) => setFormData({ ...formData, target: e.target.value })}
            required
            stretch
          />
          <PdsTextField
            label="Title"
            placeholder="Short title for this case..."
            value={formData.title}
            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
            stretch
          />
          <PdsTextArea
            label="Context"
            placeholder="Describe the case and node objectives..."
            value={formData.description}
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            rows={4}
            stretch
          />
          <PdsTextField
            label="JIRA Ticket (if relevant)"
            placeholder="RRP-001"
            value={formData.jiraId}
            onChange={(e) => setFormData({ ...formData, jiraId: e.target.value })}
            stretch
          />
        </PdsBox>
      </PdsModalBody>
      <PdsModalFooter>
        <PdsBox direction="row" justifyContent="end" gap="sm">
          <PdsMantineButton rank="outline" color="neutral" onClick={onClose} disabled={submitting}>Cancel</PdsMantineButton>
          <PdsMantineButton rank="fill" color="action" onClick={handleSubmit} disabled={submitting || !formData.target.trim()} leadingIcon={submitting ? <PdsSpinnerIcon /> : <PdsCheckConfirmIcon />}>
            {submitting ? 'Updating...' : 'Update Case'}
          </PdsMantineButton>
        </PdsBox>
      </PdsModalFooter>
    </PdsModal>
  );
}
